import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "pl-1"
}
const _hoisted_2 = { class: "ml-3 text-black" }
const _hoisted_3 = { class: "ml-3 text-black" }
const _hoisted_4 = {
  class: "d-flex align-center pl-3",
  style: {"width":"100%"}
}
const _hoisted_5 = {
  key: 0,
  class: "mr-3"
}
const _hoisted_6 = {
  class: "d-block pt-2 pb-2",
  style: {"flex":"1"}
}
const _hoisted_7 = { class: "d-flex align-center" }
const _hoisted_8 = {
  class: "text-grey mt-1",
  style: {"max-width":"10em","white-space":"pre-wrap","word-break":"break-all"}
}
const _hoisted_9 = {
  key: 1,
  class: "pl-1"
}
const _hoisted_10 = { class: "ml-3 text-black" }
const _hoisted_11 = { class: "ml-3 text-black" }
const _hoisted_12 = { class: "mr-3" }
const _hoisted_13 = { class: "d-block pt-1 pb-2" }
const _hoisted_14 = { class: "d-flex flex-column" }
const _hoisted_15 = { class: "pr-1" }
const _hoisted_16 = { class: "pr-1" }
const _hoisted_17 = {
  class: "text-grey mt-1",
  style: {"max-width":"10em","white-space":"pre-wrap","word-break":"break-all"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_ClassFilterDialog = _resolveComponent("ClassFilterDialog")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_v_list_subheader = _resolveComponent("v-list-subheader")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_VueLoading = _resolveComponent("VueLoading")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_footer = _resolveComponent("v-footer")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_app_bar, {
      color: "primary",
      dark: "",
      flat: "",
      class: "header"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_btn, {
          style: {"position":"absolute"},
          icon: "",
          onClick: _ctx.routerBack
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, null, {
              default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                _createTextVNode("mdi-chevron-left", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_v_spacer),
        _createVNode(_component_v_toolbar_title, { style: {"min-width":"fit-content"} }, {
          default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
            _createTextVNode("下書き一覧", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_v_spacer),
        _createVNode(_component_ClassFilterDialog, {
          modelValue: _ctx.selectedClassIds,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedClassIds) = $event)),
          classes: _ctx.nurseryClasses,
          onApply: _ctx.onFilterApply
        }, null, 8, ["modelValue", "classes", "onApply"])
      ]),
      _: 1
    }),
    _createVNode(_component_v_container, { class: "padding-box" }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_v_list, null, {
            default: _withCtx(() => [
              (!_ctx.fetchLoading)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _cache[11] || (_cache[11] = _createElementVNode("div", { class: "font-weight-bold pa-1" }, "個別対応", -1)),
                    (_ctx.chatsDraft.length === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_1, "保存メールがありません"))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chatsDraft, (chat, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: chat.chatId
                      }, [
                        (index > 0)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (chat.date !== _ctx.chatsDraft[index - 1].date)
                                ? (_openBlock(), _createBlock(_component_v_list_subheader, {
                                    key: 0,
                                    class: "attendance-list-header"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.formatDate(chat.date)), 1)
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true)
                            ], 64))
                          : _createCommentVNode("", true),
                        (index === 0)
                          ? (_openBlock(), _createBlock(_component_v_list_subheader, {
                              key: 1,
                              class: "attendance-list-header"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.formatDate(chat.date)), 1)
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true),
                        _createVNode(_component_v_list_item, {
                          onClick: ($event: any) => (_ctx.toChat(chat)),
                          value: chat.chatId
                        }, {
                          append: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                              default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                                _createTextVNode("mdi-chevron-right", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_4, [
                              (_ctx.checkReadyMine(chat.createdBy))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                    _createVNode(_component_v_checkbox, {
                                      modelValue: _ctx.checkbox,
                                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.checkbox) = $event)),
                                      value: chat.chatId,
                                      "hide-details": "",
                                      density: "compact",
                                      onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
                                    }, null, 8, ["modelValue", "value"])
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("div", _hoisted_7, [
                                  _createElementVNode("p", null, _toDisplayString(chat.child.lastName) + " " + _toDisplayString(chat.child.firstName), 1),
                                  _createVNode(_component_v_chip, {
                                    color: "primary",
                                    class: "ml-2",
                                    variant: "outlined",
                                    size: "x-small"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(chat.createdBy?.lastName) + " " + _toDisplayString(chat.createdBy?.firstName), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.showLongText(chat.body)), 1)
                              ])
                            ])
                          ]),
                          _: 2
                        }, 1032, ["onClick", "value"])
                      ]))
                    }), 128)),
                    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "font-weight-bold pa-1" }, "一斉メッセージ", -1)),
                    (_ctx.bulkChatsDraft.length === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, "保存メールがありません"))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bulkChatsDraft, (bulkChat, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: bulkChat.groupChatId
                      }, [
                        (index > 0)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (bulkChat.date !== _ctx.bulkChatsDraft[index - 1].date)
                                ? (_openBlock(), _createBlock(_component_v_list_subheader, {
                                    key: 0,
                                    class: "attendance-list-header"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.formatDate(bulkChat.date)), 1)
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true)
                            ], 64))
                          : _createCommentVNode("", true),
                        (index === 0)
                          ? (_openBlock(), _createBlock(_component_v_list_subheader, {
                              key: 1,
                              class: "attendance-list-header"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.formatDate(bulkChat.date)), 1)
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true),
                        _createVNode(_component_v_list_item, {
                          onClick: ($event: any) => (_ctx.toChatBulk(bulkChat))
                        }, {
                          prepend: _withCtx(() => [
                            _createElementVNode("div", _hoisted_12, [
                              (_ctx.checkReadyMine(bulkChat.createdBy))
                                ? (_openBlock(), _createBlock(_component_v_checkbox, {
                                    key: 0,
                                    modelValue: _ctx.checkboxBulk,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.checkboxBulk) = $event)),
                                    value: bulkChat.groupChatId,
                                    "hide-details": "",
                                    onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
                                  }, null, 8, ["modelValue", "value"]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          append: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                              default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                _createTextVNode("mdi-chevron-right", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("div", null, [
                              _createElementVNode("div", _hoisted_13, [
                                _createElementVNode("div", _hoisted_14, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bulkChat.to.classes, (clas) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: clas.classId
                                    }, [
                                      _createElementVNode("p", _hoisted_15, _toDisplayString(clas.className), 1)
                                    ]))
                                  }), 128))
                                ]),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bulkChat.to.children, (child) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: child.childId
                                  }, [
                                    _createElementVNode("p", _hoisted_16, _toDisplayString(child.lastName) + " " + _toDisplayString(child.firstName), 1)
                                  ]))
                                }), 128)),
                                _createVNode(_component_v_chip, {
                                  color: "primary",
                                  variant: "outlined",
                                  size: "x-small",
                                  class: "mb-2"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(bulkChat.createdBy?.lastName) + " " + _toDisplayString(bulkChat.createdBy?.firstName), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.showLongText(bulkChat.body)), 1)
                              ])
                            ]),
                            _createVNode(_component_v_divider, { class: "my-2" })
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]))
                    }), 128))
                  ], 64))
                : (_openBlock(), _createBlock(_component_VueLoading, {
                    key: 1,
                    height: '50vh'
                  }))
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_v_footer, {
      color: "white",
      class: "draft-footer"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, { class: "mt-2 mb-2 d-flex justify-center" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "6",
              class: "pr-2 pl-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  class: "",
                  color: "error",
                  variant: "outlined",
                  width: "100%",
                  onClick: _ctx.deleteChatDraft,
                  loading: _ctx.btnLoading,
                  disabled: !(_ctx.checkbox.length > 0 || _ctx.checkboxBulk.length > 0)
                }, {
                  default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", { class: "text-h6 font-weight-bold message-btn" }, "削除")
                    ], -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick", "loading", "disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_snackbar, {
      modelValue: _ctx.snackbar,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.snackbar) = $event)),
      timeout: _ctx.timeout,
      outlined: "",
      top: "",
      color: "primary"
    }, {
      actions: _withCtx(() => [
        _createVNode(_component_v_btn, {
          color: "outline-primary",
          variant: "text",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.snackbar = false))
        }, {
          default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
            _createTextVNode(" × ", -1)
          ]))]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.snackBarText) + " ", 1)
      ]),
      _: 1
    }, 8, ["modelValue", "timeout"])
  ]))
}